import 'leaflet/dist/leaflet.css'
import L from 'leaflet/dist/leaflet.js'
import 'map/scss/_map.scss'
import $ from 'jquery'
import MediaQueries from 'media-queries'
import 'leaflet.fullscreen/Control.FullScreen.js'

const icon = wp_helpers.plugin_url + '/assets/map-pin-cyan@4x.png'
const iconFocus = wp_helpers.plugin_url + '/assets/map-pin-darker-blue@4x.png'

const DK_ICON = L.icon({
   iconUrl: icon,
   iconSize: [40, 50],
   iconAnchor: [20, 50],
   popupAnchor: [0, -50]
});

const DK_HIGHLIGHT_ICON = L.icon({
   iconUrl: iconFocus,
   iconSize: [40, 50],
   iconAnchor: [20, 50],
   popupAnchor: [0, -50]
});


export class DkMap {
   constructor(elem) {
      const accordion_parents = $(elem).closest('.accordion-item');
      if ( accordion_parents.length > 0) {
         let currAccordion = accordion_parents.closest('.accordion');

         if( $(currAccordion).hasClass("special") && MediaQueries.mediumBreakpoint ){
            this.init(elem);
         }else{
            currAccordion.on('down.zf.accordion',
               (e) => {
                  this.init(elem);
               })
         }

      } else {
         this.init(elem);
      }
   }

   init(elem) {

      const $this = $(elem),
         mapid = $this.data('mapid'),
         lat = $this.data('lat'),
         lng = $this.data('lng'),
         zoom_mobile = $this.data('zoom-mobile'),
         zoom_desktop = $this.data('zoom-desktop');
      let zoom;
      let autoPan;

      //Check the sizes.
      if (MediaQueries.mediumBreakpoint) {
         zoom = zoom_desktop;
         autoPan = true;
      }else{
         zoom = zoom_mobile;
         autoPan = false;
      }

      this.elem = elem;
      try {
         this.map = L.map(mapid, {
            fullscreenControl: true
         }).setView([lat, lng], zoom);
         let currentMap = this.map;

         this.id = $this.attr("id");

         this.tile = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
         }).addTo(this.map);

         this.markers = $('.map-marker', $this).toArray().map((e, i) => {
            let popupContent = $(".content", e).html();
            let currentMap = this.elem;

            if (typeof popupContent !== 'undefined') {
               let popupMarker = L.marker([$(e).data('lat'), $(e).data('lng')], {
                     icon: DK_ICON
                  })
                  .bindPopup(popupContent, {'autoPan': autoPan})
                  .on("mouseover", function(e) {
                     e.target.setIcon(DK_HIGHLIGHT_ICON);
                     e.target._icon.classList.add("popupmarker");
                  })
                  .on("mouseout", function(e) {
                     e.target.setIcon(DK_ICON);
                     e.target._icon.classList.add("popupmarker");
                  })
                  .on("popupopen", function(e) {
                     e.target.setIcon(DK_HIGHLIGHT_ICON);
                     $(currentMap).parents(".map-wrapper").addClass("popupopen");

                     popupMarker.on("mouseover", function(e) {
                        popupMarker.setIcon(DK_HIGHLIGHT_ICON);
                        popupMarker._icon.classList.add("popupmarker");
                     }).on("mouseout", function(e) {
                        popupMarker.setIcon(DK_HIGHLIGHT_ICON);
                        popupMarker._icon.classList.add("popupmarker");
                     })
                  })
                  .on("popupclose", function(e) {
                     e.target.setIcon(DK_ICON);
                     $(currentMap).parents(".map-wrapper").removeClass("popupopen");

                     popupMarker.on("mouseover", function(e) {
                        popupMarker.setIcon(DK_HIGHLIGHT_ICON);
                        popupMarker._icon.classList.add("popupmarker");
                     }).on("mouseout", function(e) {
                        popupMarker.setIcon(DK_ICON);
                        popupMarker._icon.classList.add("popupmarker");
                     })
                  }).addTo(this.map);

            } else {
               L.marker([$(e).data('lat'), $(e).data('lng')], {
                  icon: DK_ICON
               }).addTo(this.map);
            }
         });
      } catch (error) {

      }
   }
}

export default class DkMapsManager {
   constructor() {
      this.maps = $('.map-wrapper .map .map-container').toArray().reduce((a, e) => ({
         [e.id]: new DkMap(e),
         ...a
      }), {});
   }

   triggerInitialized() {
      const map_initialized_event = new CustomEvent('initialized.DkMap', {
         detail: this.maps
      })
      document.dispatchEvent(map_initialized_event)
   }
}